<div
  class="device-list-loading-wrapper"
  [style.min-height.px]="containerHeight"
  [class.loading]="loading"
>
  <!-- No devices message -->
  <div *ngIf="noDevices" class="d-flex justify-content-center align-items-center" style="min-height: 200px">
    {{ 'info.no_devices' | translate }}
  </div>

  <!-- Table content -->
  <table *ngIf="!noDevices" mat-table [dataSource]="items" class="spotlab-table" style="width: 100%" [class.dimmed]="loading">
  <ng-container matColumnDef="organization">
    <th mat-header-cell *matHeaderCellDef>
      {{ 'core.organization' | translate | uppercase }}
    </th>
    <td mat-cell *matCellDef="let item">
      <img
        [src]="item.organizationLogoUrl || 'assets/media/organization_placeholder.svg'"
        class="user-avatar--32"
        style="margin-right: 10px; object-fit: contain; object-position: center"
      />
      <span class="text-nowrap">{{ item.organizationName || 'core.unknown' | translate }}</span>
    </td>
  </ng-container>

  <ng-container matColumnDef="device">
    <th mat-header-cell *matHeaderCellDef>
      {{ 'core.name' | translate | uppercase }}
    </th>
    <td mat-cell *matCellDef="let item" [class.device-name-cell]="!clickableRows">
      {{ item.name }}
    </td>
  </ng-container>
  <ng-container matColumnDef="name">
    <th mat-header-cell *matHeaderCellDef>
      {{ 'label.device_type_name' | translate | uppercase }}
    </th>
    <td mat-cell *matCellDef="let item">
      {{ item.deviceTypeName }}
    </td>
  </ng-container>
  <ng-container matColumnDef="version">
    <th mat-header-cell *matHeaderCellDef>
      {{ 'core.version' | translate | uppercase }}
    </th>
    <td mat-cell *matCellDef="let item">
      {{ item.deviceTypeVersion | uppercase }}
    </td>
  </ng-container>
  <ng-container matColumnDef="serialNumber">
    <th mat-header-cell *matHeaderCellDef>
      {{ 'label.serial_number' | translate | uppercase }}
    </th>
    <td mat-cell *matCellDef="let item">
      {{ item.serialNumber }}
    </td>
  </ng-container>
  <ng-container matColumnDef="purchaseDate">
    <th mat-header-cell *matHeaderCellDef>
      {{ 'props.acquired_on' | translate | uppercase }}
    </th>
    <td mat-cell *matCellDef="let item">
      {{ item.createdAt | date : 'short' }}
    </td>
  </ng-container>
  <tr mat-header-row *matHeaderRowDef="visibleColumns"></tr>
  <tr
    mat-row
    *matRowDef="let item; columns: visibleColumns"
    (click)="deviceClicked.emit(item)"
    [class.clickable-row]="clickableRows"
    [class.hoverable-row]="true"
  ></tr>
  </table>

  <!-- Loading Overlay -->
  <div *ngIf="loading" class="device-list-loading-overlay">
    <div class="device-list-loading-content">
      <ts-list-loading-indicator></ts-list-loading-indicator>
    </div>
  </div>
</div>
